import { getGameSituation } from '../game-situation.ts'
import { GameSituation } from '../types/game-situation.ts'
import applyHeatmap from './heatmaps.ts'
import { FlattenedCountRow } from '../types/run-expectancy.ts'

export default function renderRunExpectancyByRunnerSelectedTable(
    data: FlattenedCountRow[]
) {
    if (!data.length) {
        console.warn('No run expectancy by count data returned')
    }

    const table = `
<table id="tbl-run-exp-by-runner-selected">
  <thead>
    <tr><th></th></tr>
    <tr class="tr-component-row">
      <th class="th-component-header align-center">Runners</th>
      <th class="th-component-header align-center">Outs</th>
      <th class="th-component-header align-center">Balls</th>
      <th class="th-component-header align-center" data-strikes="0">0 Strikes</th>
      <th class="th-component-header align-center" data-strikes="1">1 Strike</th>
      <th class="th-component-header align-center" data-strikes="2">2 Strikes</th>
    </tr>
  </thead>
  <tbody>
    ${data
        .map(
            (row) => `
<tr class="default-table-row" data-balls="${row.balls}">
  <td class="tr-data align-center">${row.bases}</td>
  <td class="tr-data align-center">${row.outs}</td>
  <td class="tr-data align-center">${row.balls}</td>
  <td class="tr-data align-center" data-situation="${row.balls}0">${
                row.run_exp_strikes_0 != null
                    ? row.run_exp_strikes_0.toFixed(3)
                    : ''
            }</td>
  <td class="tr-data align-center" data-situation="${row.balls}1">${
                row.run_exp_strikes_1 != null
                    ? row.run_exp_strikes_1.toFixed(3)
                    : ''
            }</td>
  <td class="tr-data align-center" data-situation="${row.balls}2">${
                row.run_exp_strikes_2 != null
                    ? row.run_exp_strikes_2.toFixed(3)
                    : ''
            }</td>
</tr>`
        )
        .join('')}
  </tbody>
</table>
`

    const el = document.getElementById('run-exp-runner')

    if (el) {
        el.innerHTML = table
    }

    applyHeatmap('tbl-run-exp-by-runner-selected')
    highlightRunExpectancyRowByRunnerSelected(getGameSituation())
}

function highlightRunExpectancyRowByRunnerSelected(
    situation: Partial<GameSituation>
) {
    // Clear previous highlights ONLY in the by-count table
    document
        .querySelectorAll('#run-exp-runner .cell-highlight')
        .forEach((el) => el.classList.remove('cell-highlight'))
    if (situation.balls == null || situation.strikes == null) {
        return
    }

    const countKey = `${situation.balls}`

    const rows = document.querySelectorAll<HTMLTableRowElement>(
        '#run-exp-runner table tbody tr'
    )

    rows.forEach((row) => {
        if (row.dataset.balls !== countKey) return

        const cell = row.querySelector<HTMLElement>(
            `[data-situation="${countKey}${situation.strikes}"]`
        )

        if (cell) {
            cell.classList.add('cell-highlight')
        }
    })
}
